<div class="TextareaWithCounter">
  <mat-form-field class="TextareaInput TextareaWithCounter-input">
    <mat-label>{{ label() }}</mat-label>
    <textarea
      #inputRef="ngModel"
      #textareaEl
      matInput
      autocomplete="off"
      [placeholder]="placeholder()"
      [class]="className()"
      [attr.maxlength]="maxLength()"
      [style.minHeight.px]="minHeight()"
      [attr.disabled]="disabled ? true : null"
      [disabled]="disabled"
      [required]="required()"
      [ngModel]="value"
      (ngModelChange)="onChange($event)"
      (keydown)="handleKeydown($event)"
      (blur)="onBlur()">
    </textarea>
    @if (iconClass() || iconName()) {
      <mat-icon matSuffix [class]="iconClass()">{{ iconName() }}</mat-icon>
    }
    <mat-hint>
      @if (hint()) {
        {{ hint() }}
      }
      <ng-content />
    </mat-hint>
    <mat-hint align="end"> {{ counter }}/{{ maxLength() }} </mat-hint>
  </mat-form-field>
</div>
